import { render, staticRenderFns } from "./AboutPage1.vue?vue&type=template&id=0f2ead9d&scoped=true"
import script from "./AboutPage1.vue?vue&type=script&lang=js"
export * from "./AboutPage1.vue?vue&type=script&lang=js"
import style0 from "./AboutPage1.vue?vue&type=style&index=0&id=0f2ead9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2ead9d",
  null
  
)

export default component.exports